const doc = [({"en":({"activerecord":({"attributes":({"user_element":({"file":"File"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;